/* Stylesheet */

.app_toolbar {
  padding: 4px;
  display: flex;
  height: 58px;
  align-items: center;
  justify-content: space-between;

  transition: background 0.3s ease, color 0.3s ease,
    box-shadow 0.3s ease;

  .menu_button_container {
    display: flex;
    align-items: center;

    .menu_button {
      height: 48px;
      width: 48px;
      --color: var(--ion-color-text-primary);
    }

    .page_title {
      margin: 0px 0px 0px 12px;
      color: var(--ion-color-text-primary);
    }
  }

  .options_container {
    display: flex;
    align-items: center;

    .assistant_button {
      margin: 0px 8px 0px 0px;
      height: 48px;
      width: 48px;
      --color: var(--ion-color-text-primary);
    }

    .filter_menu_button {
      margin: 0px 8px 0px 0px;
      height: 48px;
      width: 48px;
      --color: var(--ion-color-text-primary);
    }
  }
}
